import { MqlCompiledQuery } from '@deqo/mql-js';
import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface LensInfo {
    readonly type: string;
    readonly filter: MqlCompiledQuery;
}

export const CreateLensInfo = (type: string, filter: MqlCompiledQuery): LensInfo => ({ type, filter });
export const LensInfo = StatePropertyRef<LensInfo>('lens', CreateLensInfo('none', null));
